import ProductGrid from "~/components/ProductGrid";
import {
  getCommonSliceProps,
  getMediaArrayFromImage,
  getRichText,
  resolveMedia,
} from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

function addColor(colors, slug, name) {
  const key = (slug || "").trim().toLowerCase();
  if (!key || colors.some((c) => c.slug === key)) return;
  colors.push({ slug: key, name: name || key });
}

function getAvailableColors(ctpProduct, prismicColor, prismicProducts = {}) {
  const colors = [];
  (ctpProduct?.variants || []).forEach((v) => {
    if (v.color?.slug) addColor(colors, v.color.slug, v.color.name);
  });
  if (prismicColor) addColor(colors, prismicColor);
  Object.values(prismicProducts).forEach((doc) => {
    if (doc?.data?.key === ctpProduct?.key && doc.data.color) {
      addColor(colors, doc.data.color);
    }
  });
  return colors;
}

export function mapSliceToProps(slice, externalData) {
  const { primary, items = [] } = slice;

  // console.log('SLICE', slice.primary.sound_profile); // .data

  const {
    products = [],
    configurations = [],
    categories = [],
    prismicProducts = {},
  } = externalData;
  // console.log('externalData', externalData);

  // console.log(slice);
  const prs = items.map((i) => i.product);
  // console.log(prs);

  let category = null;

  // check if category has data...
  if (primary.category.hasOwnProperty("data")) {
    // console.log('CAT', primary.category);
    const categoryMatch = categories.find((c) => c.key === primary.category.data.key);
    if (categoryMatch) {
      category = categoryMatch;
    }
  }

  let cards = [];
  if (category) {
    // either get carts from category
    const categoryProducts = category.products;
    categoryProducts.sort((a, b) => (a.key > b.key ? 1 : -1));
    cards = categoryProducts.map((pr) => {
      const prismicDoc = prismicProducts[pr.key]?.data;
      const mainImage = prismicDoc?.main_image;
      const hoverImage = prismicDoc?.hover_image;
      return {
        product: pr,
        availableColors: getAvailableColors(pr, prismicDoc?.color, prismicProducts),
        media: mainImage?.url
          ? getMediaArrayFromImage(mainImage.large || mainImage)
          : undefined,
        hoverMedia: hoverImage?.url
          ? getMediaArrayFromImage(hoverImage.large || hoverImage)
          : undefined,
        customOutOfStockText: prismicDoc?.["custom_out_of_stock_button_text"] ?? null,
      };
    });
  } else {
    // or from the items (repeatable field...)
    cards = items.map((item) => {
      // console.log(item);

      // Resolve variantKey: prefer product.data.color, fall back to legacy variant_key field
      let variantKey = item.variant_key || undefined;
      if (item.product?.type === "product" && item.product.data?.color) {
        const ctpProduct = products.find((pr) => pr.key === item.product.data.key);
        const normalizedColor = item.product.data.color.trim().toLowerCase();
        const colorVariant = ctpProduct?.variants?.find(
          (v) => v.color?.slug?.toLowerCase() === normalizedColor
        );
        if (colorVariant) variantKey = colorVariant.key;
      }

      const prismicProductDoc = item.product?.uid
        ? prismicProducts[item.product.uid]?.data
        : null;

      const obj = {
        media: resolveMedia(item, "1:1"),
        title: item.title,
        subtitle: item.subtitle,
        text: getRichText(item.text),
        variantKey,
        buttonText: item.button_text,
        customOutOfStockText:
          prismicProductDoc?.["custom_out_of_stock_button_text"] ?? null,
        ...(item.link_override ? { href: item.link_override } : {}),
      };

      if (item.sound_profile) {
        if (item.sound_profile.data) {
          obj.soundProfile = item.sound_profile.data;
        }
      }

      if (item.product.type === "product") {
        obj.product = products.find((pr) => pr.key === item.product.data.key);
        obj.availableColors = getAvailableColors(
          obj.product,
          item.product.data?.color,
          prismicProducts
        );
        const mainImage = item.product.data?.main_image;
        if (mainImage?.url && !obj.media) {
          obj.media = getMediaArrayFromImage(mainImage.large || mainImage);
        }
        const hoverImage = item.product.data?.hover_image;
        if (hoverImage?.url) {
          obj.hoverMedia = getMediaArrayFromImage(hoverImage.large || hoverImage);
        }
      } else if (item.product.type === "variant") {
        // find the configuration that matches the uid!
        const configuration = configurations.find((c) => c.uid === item.product.uid);
        if (configuration) {
          // console.log(configuration);
          obj.product = configuration;
          // set title
          obj.title = configuration.data.product_title;
          // set descriotion
          obj.text = getRichText(configuration.data.description);
          // media
          obj.media = [
            configuration.data.image.url,
            "image",
            configuration.data.image.width,
            configuration.data.image.height,
          ];
        }
      }

      return obj;
    });
  }

  const props = {
    ...getCommonSliceProps(slice),

    // ctpCategoryKey: primary.ctp_category_key,
    type: primary.card_type && primary.card_type.charAt(0).toLowerCase(), // getType(primary.card_type), // primary.card_type === 'A' ? 'a' : 'b', // card_type
    buttonType: primary.button_type && primary.button_type.toLowerCase(),
    buttonAction: primary.button_action && primary.button_action.toLowerCase(),
    showText: (primary.text_type || "").toLowerCase() !== "hidden",
    columnsOnDesktop: primary.columns_on_desktop || 4,
    columnsOnMobile: primary.columns_on_mobile || 1,
    horizontalScroll: (primary.style || "").toLowerCase() === "slider",
    visibleCardsOnDesktop:
      primary.visible_products_on_desktop ||
      primary.visible_products ||
      primary.visible_cards ||
      3.2,
    visibleCardsOnMobile: primary.visible_products_on_mobile || 1.15,

    cards, // resolved above...
  };
  return props;
}

export default connectSlice(mapSliceToProps)(ProductGrid);
